import { render, staticRenderFns } from "./dialog_data_source.vue?vue&type=template&id=1261ccec&scoped=true&lang=html"
import script from "./dialog_data_source.vue?vue&type=script&lang=js"
export * from "./dialog_data_source.vue?vue&type=script&lang=js"
import style0 from "./dialog_data_source.vue?vue&type=style&index=0&id=1261ccec&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1261ccec",
  null
  
)

export default component.exports